import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--spacing-x-large);
	.header-text {
		display: flex;
		flex-direction: column;
		gap: var(--spacing-medium);
	}
`;
